/** @jsxRuntime classic */
/** @jsx jsx */
import { Dialog } from '@bottlebooks/gatsby-theme-base/src';
export default Dialog;
